export const PLAN_TYPES = {
  single: "single",
  family: "family",
};
